import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignalsSection = () => {
  const trustSignals = [
    {
      iconName: "Shield",
      title: "Privacy First",
      description: "Your identity is never stored or shared. All posts are automatically anonymized before publication."
    },
    {
      iconName: "Lock",
      title: "Secure Platform",
      description: "End-to-end encryption ensures your emotional expressions remain private and protected."
    },
    {
      iconName: "Users",
      title: "Community Guidelines",
      description: "Strict moderation and curated reactions maintain a supportive, judgment-free environment."
    },
    {
      iconName: "Eye",
      title: "No Tracking",
      description: "We don't track your activity or sell your data. Your emotional journey is yours alone."
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-background">
      <div className="container mx-auto max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16 space-y-3 md:space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 rounded-full mb-4">
            <Icon name="ShieldCheck" size={20} color="var(--color-success)" strokeWidth={2} />
            <span className="caption text-success font-medium">Your Safety Matters</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            Built on Trust &amp; Privacy
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            We've designed every aspect of OnlyCuts to protect your identity and create a safe space for emotional expression.
          </p>
        </div>

        {/* Trust signals grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {trustSignals?.map((signal, index) => (
            <div 
              key={index}
              className="flex gap-4 md:gap-6 p-5 md:p-6 lg:p-8 bg-card rounded-xl md:rounded-2xl border border-border transition-therapeutic hover:shadow-md"
            >
              <div className="flex-shrink-0">
                <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-success/10 rounded-lg">
                  <Icon 
                    name={signal?.iconName} 
                    size={24} 
                    color="var(--color-success)" 
                    strokeWidth={2}
                  />
                </div>
              </div>
              
              <div className="space-y-2">
                <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-foreground">
                  {signal?.title}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {signal?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional trust badges */}
        <div className="mt-10 md:mt-12 lg:mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-8 lg:gap-12">
          <div className="flex items-center gap-3 px-5 py-3 bg-card rounded-lg border border-border">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2} />
            <span className="text-sm md:text-base font-medium text-foreground">GDPR Compliant</span>
          </div>
          
          <div className="flex items-center gap-3 px-5 py-3 bg-card rounded-lg border border-border">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2} />
            <span className="text-sm md:text-base font-medium text-foreground">SSL Encrypted</span>
          </div>
          
          <div className="flex items-center gap-3 px-5 py-3 bg-card rounded-lg border border-border">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2} />
            <span className="text-sm md:text-base font-medium text-foreground">No Data Selling</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignalsSection;